<template>
  <input-base :name="name" :label="label" :placeholder="placeholder"
    :errorMessage="errorMessage"
    :meta="meta"
  >
    <input
      ref="input"
      class="form-control"
      type="text"
      :value="inputValue"
      :placeholder="placeholder ? label : ''"
      @input="changeValue"
      @blur="handleBlur"
    />
  </input-base>
</template>

<script>
import { ref } from "vue"
import { useField } from "vee-validate"
import InputBase from "@/components/layout/forms/Input.vue"

export default {
  components: {
    InputBase,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  setup(props, { emit }) {
    const input = ref(null)

    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(props.name || props.label, undefined, {
      initialValue: props.modelValue,
    })

    function changeValue(evt) {
      handleChange(evt)
      emit('update:modelValue', evt.target.value)
    }

    return {
      changeValue,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
      input,
    }
  },
}
</script>

<style scoped></style>
